import { shorthands, mergeClasses, __styles } from '@griffel/react';
import { tokens } from '@fluentui/react-theme';
export const menuDividerClassNames = {
  root: 'fui-MenuDivider'
};
const useStyles = /*#__PURE__*/__styles({
  root: {
    B6of3ja: "fvjh0tl",
    t21cq0: ["f1rnx978", "f1q7jvqi"],
    jrapky: "fd1gkq",
    Frg6f3: ["f1q7jvqi", "f1rnx978"],
    a9b677: "f14z66ap",
    Bn0qgzm: "f1vxd6vx",
    oivjwe: "fg706s2",
    B9xav0g: "frpde29"
  }
}, {
  d: [".fvjh0tl{margin-top:4px;}", ".f1rnx978{margin-right:-5px;}", ".f1q7jvqi{margin-left:-5px;}", ".fd1gkq{margin-bottom:4px;}", ".f14z66ap{width:auto;}", ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}", ".fg706s2{border-bottom-style:solid;}", ".frpde29{border-bottom-color:var(--colorNeutralStroke2);}"]
});
export const useMenuDividerStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(menuDividerClassNames.root, styles.root, state.root.className);
  return state;
};
//# sourceMappingURL=useMenuDividerStyles.styles.js.map